import React, { useCallback, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { TriggerForm } from './TriggerForm';
import { useErrorInputs } from '../../../../hooks/useErrorInputs';
import { useForm } from '../../../../hooks/useForm';
import { IconButton, Tooltip } from '@mui/material';
import { AddTask, Info } from '@mui/icons-material';
import TableActionBiasic from '../TableActionBasic';
import { useNotification } from '../../../../hooks/useNotification';
import { validateAndEnsureArray } from '../../../../utils/jsonValidator';
import { CHART_TYPE_OPTIONS, INITIAL_CHART_FORM } from '../../constants/interface.constants';

export const ChartReportForm = ({ data, handleDirectInputChange, t }) => {
    const [sendNotification] = useNotification();
    const [errorInputs, , , validForm] = useErrorInputs({});
    const [errorInputsTrigger, , , validFormTrigger] = useErrorInputs({});
    const [values, handleInputChange, handleDirectInput, setAllInfo, reset] = useForm(INITIAL_CHART_FORM);
    const [charts, setcharts] = useState(validateAndEnsureArray(data?.charts));

    const handleSize = ({ target }) => {
        setAllInfo(prev => ({
            ...prev,
            chart: {
                size: {
                    ...prev.chart.size,
                    [target.name]: target.value
                }
            }
        }))
    }

    const handleTriggerData = useCallback((obj) => {
        handleDirectInput('trigger', obj);
    }, [handleDirectInput])

    const handleAddChart = () => {
        if (validForm(['accion', 'type', 'color', 'chart.size.gridColumn', 'chart.size.gridRow'], values)
            && validFormTrigger(['type', 'subtype', 'method', 'url'], values.trigger[0])) {
            setcharts([...charts, values]);
            reset();
        }
    }

    useEffect(() => {
        handleDirectInputChange('charts', charts);
    }, [charts])

    const handleDelete = (index) => {
        setcharts(prevItems => prevItems.filter((_, i) => i !== index));
    }

    return (
        <Box>
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid size={{xs:10, sm:10}}>
                    <Typography variant='h6' component='h6'>
                        Grafica
                    </Typography>
                </Grid>

                <Grid size={{xs:2, sm:2}} sx={{ display: 'flex' }}>
                    <Tooltip title={t('add')}>
                        <IconButton
                            sx={{
                                color: 'blue',
                            }}
                            onClick={() => handleAddChart()}
                        >
                            <AddTask />
                        </IconButton>
                    </Tooltip>
                    <IconButton
                        sx={{
                            color: 'green',
                        }}
                        onClick={() => sendNotification({
                            msg: `Tenga en cuenta que la pantalla esta dividida en 12 columnas y 12 filas.
                            Si quiere agregar mas de una grafica tenga en cuenta esto, puesto que estas se mostraran en base a los tamañon que defina.` })}
                    >
                        <Info />
                    </IconButton>
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid size={{xs:12, sm:6}}>
                    <TextField
                        fullWidth
                        size="small"
                        name="accion"
                        label={t("interface.name")}
                        value={values.accion}
                        onChange={handleInputChange}
                        error={!!errorInputs.accion?.isError}
                        helperText={errorInputs.accion?.messageError}
                        required
                    />
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <FormControl
                        fullWidth
                        size='small'
                        error={Boolean(errorInputs.type?.isError)}
                        required
                    >
                        <InputLabel id="type">{t("interface.type")}</InputLabel>
                        <Select
                            label={t("interface.type")}
                            name='type'
                            value={values.type}
                            onChange={handleInputChange}
                        >
                            {CHART_TYPE_OPTIONS.map((option) => (
                                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                            ))}
                        </Select>
                        {errorInputs.type?.isError && (
                            <FormHelperText>{errorInputs.type.messageError}</FormHelperText>
                        )}
                    </FormControl>
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <TextField
                        label="Color"
                        name="color"
                        value={values.color}
                        onChange={handleInputChange}
                        fullWidth
                        size='small'
                        variant="outlined"
                        error={!!errorInputs.color?.isError}
                        helperText={errorInputs.color?.messageError}
                        required
                    />
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <TextField
                        label="Ancho de la grafica"
                        name="gridColumn"
                        value={values.chart.size.gridColumn}
                        onChange={handleSize}
                        fullWidth
                        size='small'
                        variant="outlined"
                        error={!!errorInputs["chart.size.gridColumn"]?.isError}
                        helperText={errorInputs["chart.size.gridColumn"]?.messageError}
                        required
                    />
                </Grid>

                <Grid size={{xs:12, sm:6}}>
                    <TextField
                        label="Alto de la grafica"
                        name="gridRow"
                        value={values.chart.size.gridRow}
                        onChange={handleSize}
                        fullWidth
                        size='small'
                        variant="outlined"
                        error={!!errorInputs["chart.size.gridRow"]?.isError}
                        helperText={errorInputs["chart.size.gridRow"]?.messageError}
                        required
                    />
                </Grid>

                <Grid>
                    <TriggerForm
                        values={values.trigger[0]}
                        errorInputs={errorInputsTrigger}
                        onFieldsChange={handleTriggerData}
                        t={t}
                    />
                </Grid>

                <Grid size={{xs:12, md:12}}>
                    {
                        charts.length > 0 &&
                        <TableActionBiasic
                            columns={[
                                { label: 'Nombre', id: 'accion' },
                                { label: 'Tipo', id: 'type' }
                            ]}
                            values={charts}
                            handleDelete={(id, idx) => handleDelete(idx)}
                            t={t}
                        />
                    }
                </Grid>
            </Grid>
        </Box>
    );
}    
